import React from "react";
import { faq } from "../../mock";
import { SectionTitle } from "./Helpers";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export default function FAQSection() {
  return (
    <section className="py-20 bg-charcoal">
      <div className="container-narrow max-w-3xl">
        <SectionTitle over="Vos questions" title="Réponses claires, promesses tenues" />
        <div className="mt-10">
          <Accordion type="single" collapsible className="space-y-3">
            {faq.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="gold-border rounded-lg px-4 bg-onyx">
                <AccordionTrigger className="text-gold-soft hover:no-underline text-left">{f.q}</AccordionTrigger>
                <AccordionContent className="text-gold-soft/95">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
